import React from 'react'
import './StoryDate.css'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')

type Props = {
  date: dayjs.Dayjs
}

export default function StoryDate(props: Props) {
  return <time dateTime={props.date.format('YYYY-MM-DD')}>{props.date.format('MMM D, YYYY')}</time>
}
